import React from 'react';
import * as Sentry from '@sentry/react';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const isDev = process.env.NODE_ENV === 'development';

if (dsn) {
	Sentry.init({
		dsn,
		environment: (process.env.REACT_APP_ENV || process.env.NODE_ENV).toLowerCase(),
		sendDefaultPii: true,
		integrations: [
			Sentry.reactRouterV7BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],
		tracesSampleRate: isDev ? 1.0 : 0.2,
		tracePropagationTargets: [
			'localhost',
			/^https:\/\/(www\.)?(bidzbase|weekswelding)\.com/,
		],
		replaysSessionSampleRate: isDev ? 0 : 0.1,
		replaysOnErrorSampleRate: 1.0,
		enableLogs: true,
	});
}
